import queryAssetsByShopId from './queryAssetsByShopId';

async function queryAssetsByCastIron() {
  return await queryAssetsByShopId('castiron');
}

export default queryAssetsByCastIron;
